
/**
 *  TODO adjustments
 *  - closing animations
 *  - focus on button toggle after clicking. 
 *  - make it work with targets that are elsewhere in the markup and redirect focus when tabbing
 *  - refactoring / reusable functions + clean up
 *  - focus back to toggler => data-expander-focusback
 */

(function () {
    const expanders = [...document.querySelectorAll("[data-expander]")]
    const exitToggles = [...document.querySelectorAll("[data-expander-closer]")];
    if (expanders.length !== 0) {
        expanders.forEach(expander => {
            const buttonToggle = expander.querySelector("[data-expander-toggle]");
            const expanderId = buttonToggle.getAttribute("data-expander-toggle");
            const expanderTarget = document.getElementById(`${expanderId}`);
            const interactiveElements = [...expanderTarget.querySelectorAll("input, a, textarea, button, select")]
            const lastInteractiveElement = interactiveElements[interactiveElements.length - 1];
            const firstInteractiveElement = interactiveElements[0];
            buttonToggle.addEventListener("click", e => {
                e.stopPropagation();
                closeOthers(expanderTarget);
                if (!buttonToggle.classList.contains("show-up")) {
                    buttonToggle.classList.add('show-up');
                    expanderTarget.classList.add('show-up');
                    buttonToggle.setAttribute("aria-expanded", "true");
                    expanderTarget.setAttribute("tabindex", 0);
                }
                else {
                    buttonToggle.classList.remove('show-up');
                    expanderTarget.classList.remove('show-up');
                    buttonToggle.setAttribute("aria-expanded", "false");
                    buttonToggle.focus();
                }
                if (expander.hasAttribute("data-expander-focus")) {
                    const firstInteractiveElement = interactiveElements[0]
                    firstInteractiveElement?.focus();
                }
            })
            buttonToggle.addEventListener('keydown', e => {
                if (e.key === 'Escape') {
                    buttonToggle.click()
                }
            })
            expanderTarget.addEventListener('keydown', e => {
                if (e.key === 'Escape') {
                    buttonToggle.click()
                }
            })
            lastInteractiveElement?.addEventListener('keydown', (e) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                    setTimeout(() => {
                        buttonToggle.click()
                    }, 0);
                }
            });
            firstInteractiveElement?.addEventListener('keydown', (e) => {
                if (e.key === 'Tab' && e.shiftKey) {
                    setTimeout(() => {
                        buttonToggle.click()
                    }, 0);
                }
            }); 
        })
        // Close dropdowns when clicking outside
        document.addEventListener('click', function (event) {
            if (!event.target.matches('[data-expander-toggle]')) {
                expanders.forEach(expander => {
                    const buttonToggle = expander.querySelector("[data-expander-toggle]");
                    const expanderId = buttonToggle.getAttribute("data-expander-toggle");
                    const expanderTarget = document.getElementById(`${expanderId}`);
                    buttonToggle.classList.remove("show-up");
                    buttonToggle.setAttribute("aria-expanded", "false");
                    expanderTarget.classList.remove("show-up");
                });
            }
        });
        // Prevent closing when clicking inside a dropdown
        const dataExpanderTargets = document.querySelectorAll("[data-expander-target]");
        dataExpanderTargets?.forEach(dataExpanderTarget => {
            dataExpanderTarget.addEventListener('click', function (event) {
                event.stopPropagation();
            });
        });
        // fake toggles that can be used to close actual data expander toggles
        exitToggles?.forEach(exitToggle => {
            const toggleId = exitToggle.getAttribute("data-expander-closer");
            const buttonTarget = document.querySelector(`[data-expander-toggle="${toggleId}"]`);
            exitToggle.addEventListener("click", e => {
                console.log('praise beeeeeee')
                console.log(buttonTarget)
                buttonTarget?.click();
            })
        })
    }
    function closeOthers(currentExpanderTarget) {
        expanders.forEach(expander => {
            const buttonToggle = expander.querySelector("[data-expander-toggle]");
            const expanderId = buttonToggle.getAttribute("data-expander-toggle");
            const expanderTarget = document.getElementById(`${expanderId}`);
            if (!expanderTarget.contains(currentExpanderTarget) && !currentExpanderTarget.contains(expanderTarget)) {
                buttonToggle.classList.remove("show-up");
                buttonToggle.setAttribute("aria-expanded", "false");
                expanderTarget.classList.remove("show-up");
            }
        })
    }
})(); 